import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "50",
  height: "50",
  viewBox: "0 0 100 100"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "50",
    cy: "50",
    fill: "none",
    stroke: "var(--primary)",
    "stroke-width": "6",
    r: "35",
    "stroke-dasharray": "164.93361431346415 56.97787143782138"
  }, [
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      repeatCount: "indefinite",
      dur: "1s",
      keyTimes: "0;1",
      values: "0 50 50;360 50 50"
    })
  ])
], -1)

export function render(_ctx, _cache) {
  return (_ctx.disabled)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.cType), {
        key: 0,
        class: _normalizeClass([_ctx.className(_ctx.cClass), _ctx.cClass, 'btn-pipple-handler c-child']),
        onClick: _ctx.emitHandler,
        ref: "pippleButton",
        onDbl: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(_ctx.cValue)), 1)
        ]),
        _: 1
      }, 40, ["class", "onClick"]))
    : (!_ctx.loading)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.cType), {
          key: 1,
          class: _normalizeClass([_ctx.cClass, 'c-child', 'btn-pipple-handler']),
          onClick: _ctx.handler,
          ref: "pippleButton",
          onDbl: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "image", { row: _ctx.icon }),
            _renderSlot(_ctx.$slots, "icon"),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.cValue)), 1)
          ]),
          _: 3
        }, 40, ["class", "onClick"]))
      : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.cType), {
          key: 2,
          class: _normalizeClass([_ctx.cClass, _ctx.className(_ctx.cClass), 'btn-pipple-handler c-child']),
          onClick: _ctx.emitHandler,
          ref: "pippleButton",
          onDbl: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 40, ["class", "onClick"]))
}